function n(t) {
  return t.slice(0, 1).toUpperCase() + t.slice(1);
}
function o(t) {
  return e.format(t);
}
function a(t) {
  return r.format(t);
}
const e = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), r = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 2
});
export {
  n as capitalise,
  o as formatDollarAmount,
  a as formatPercentage
};
